module.exports = __webpack_public_path__ + "assets/images/project/people/mansenior-chart.png?v=869575e2";